export default {
    changeLang(iframe, all) {
        iframe.contentDocument.querySelector("h3").textContent = all.$t(
            "customize"
        );

        iframe.contentDocument
            .querySelectorAll("dd")[0]
            .querySelectorAll("span")[0].textContent = all.$t("manuelspin");
        var inside = iframe.contentDocument
            .querySelectorAll("dd")[0]
            .querySelectorAll("div")[0];
        inside.querySelector("p").textContent = all.$t("manuelmessage");
        inside
            .querySelectorAll("div")[0]
            .querySelectorAll("span")[0].textContent = all.$t("direction");
        inside
            .querySelectorAll("div")[1]
            .querySelectorAll("span")[0].textContent = all.$t("clockwise");
        inside
            .querySelectorAll("div")[1]
            .querySelectorAll("span")[1].textContent = all.$t("counter-clockwise");
        inside
            .querySelectorAll("div")[4]
            .querySelectorAll("span")[0].textContent = all.$t("interaction");
        inside
            .querySelectorAll("div")[5]
            .querySelectorAll("span")[0].textContent = all.$t("clickdrag");
        inside
            .querySelectorAll("div")[5]
            .querySelectorAll("span")[1].textContent = all.$t("hoverover");
        inside
            .querySelectorAll("div")[9]
            .querySelectorAll("span")[0].textContent = all.$t("sensitivity");
        inside
            .querySelectorAll("div")[14]
            .querySelectorAll("span")[0].textContent = all.$t("inertia");
        inside
            .querySelectorAll("div")[14]
            .querySelectorAll("span")[0].textContent = all.$t("inertia");
        inside
            .querySelectorAll("div")[20]
            .querySelectorAll("span")[0].textContent = all.$t("settlespeed");

        var inside1 = iframe.contentDocument
            .querySelectorAll("dd")[1]
            .querySelectorAll("div")[0];
        inside1
            .querySelectorAll("div")[1]
            .querySelectorAll("span")[0].textContent = all.$t("autospin");
        inside1.querySelector("p").textContent = all.$t("spinsettings");

        var inside2 = iframe.contentDocument
            .querySelectorAll("dd")[2]
            .querySelectorAll("div")[0];
        inside2.querySelector("p").textContent = all.$t("zoomdesc");
        inside2
            .querySelectorAll("div")[0]
            .querySelectorAll("span")[0].textContent = all.$t("magnification");
        inside2
            .querySelectorAll("div")[7]
            .querySelectorAll("span")[0].textContent = all.$t("animatespeed");

        var inside3 = iframe.contentDocument
            .querySelectorAll("dd")[3]
            .querySelectorAll("div")[0];
        inside3.querySelector("p").textContent = all.$t("fullscreendesc");
        inside3
            .querySelectorAll("div")[0]
            .querySelectorAll("span")[0].textContent = all.$t("style");
        inside3
            .querySelectorAll("div")[5]
            .querySelectorAll("span")[0].textContent = all.$t("size");
        inside3
            .querySelectorAll("div")[11]
            .querySelectorAll("span")[0].textContent = all.$t("position");

        iframe.contentDocument.getElementById('variant_fullscreen_icon_position').options[0].text = all.$t("topleft");
        iframe.contentDocument.getElementById('variant_fullscreen_icon_position').options[1].text = all.$t("topright");
        iframe.contentDocument.getElementById('variant_fullscreen_icon_position').options[2].text = all.$t("bottomleft");
        iframe.contentDocument.getElementById('variant_fullscreen_icon_position').options[3].text = all.$t("bottomright");

        var inside4 = iframe.contentDocument
            .querySelectorAll("dd")[4]
            .querySelectorAll("div")[0];
        inside4.querySelector("p").textContent = all.$t("bgdesc");
        inside4
            .querySelectorAll("div")[2]
            .querySelectorAll("span")[0].textContent = all.$t("bg-color");
        var inside5 = iframe.contentDocument
            .querySelectorAll("dd")[5]
            .querySelectorAll("div")[0];
        inside5.querySelector("p").textContent = all.$t("startonload");
        inside5
            .querySelectorAll("div")[0]
            .querySelectorAll("span")[0].textContent = all.$t("startonframe");
        inside5
            .querySelectorAll("div")[3]
            .querySelectorAll("span")[0].textContent = all.$t("setnowframe");
        inside5
            .querySelectorAll("div")[4]
            .querySelectorAll("span")[0].textContent = all.$t("load360");
        inside5
            .querySelectorAll("div")[6]
            .querySelectorAll("span")[0].textContent = all.$t("instantly");
        inside5
            .querySelectorAll("div")[7]
            .querySelectorAll("span")[0].textContent = all.$t("onclick");

        inside5
            .querySelectorAll("div")[8]
            .querySelectorAll("span")[0].textContent = all.$t("onhover");

        inside5
            .querySelectorAll("div")[9]
            .querySelectorAll("span")[0].textContent = all.$t(
                "spinsizecontroller"
            );

        inside5
            .querySelectorAll("div")[15]
            .querySelectorAll("span")[0].textContent = all.$t("loading");
        inside5
            .querySelectorAll("div")[17]
            .querySelectorAll("span")[0].textContent = all.$t("show");
        inside5
            .querySelectorAll("div")[18]
            .querySelectorAll("span")[0].textContent = all.$t("hide");

        iframe.contentDocument
            .querySelectorAll("dd")[1]
            .querySelectorAll("span")[0].textContent = all.$t("autospin");
        iframe.contentDocument
            .querySelectorAll("dd")[2]
            .querySelectorAll("span")[0].textContent = all.$t("zoom");
        iframe.contentDocument
            .querySelectorAll("dd")[3]
            .querySelectorAll("span")[0].textContent = all.$t("fullscreen");
        iframe.contentDocument
            .querySelectorAll("dd")[4]
            .querySelectorAll("span")[0].textContent = all.$t("bg");
        iframe.contentDocument
            .querySelectorAll("dd")[5]
            .querySelectorAll("span")[0].textContent = all.$t("startandload");
        iframe.contentDocument
            .querySelectorAll("dd")[6]
            .querySelectorAll("span")[0].textContent = all.$t(
                "Instruction_Message"
            );
        for (let index = 0; index < 7; index++) {
            if (index != 4 || index != 5) {
                iframe.contentDocument
                    .querySelectorAll("dd")
                [index].querySelectorAll("span")[1].textContent = all.$t("on");
                iframe.contentDocument
                    .querySelectorAll("dd")
                [index].querySelectorAll("span")[2].textContent = all.$t("off");
            }
        }
    }
}